import { useContext } from "react";
import { BlockSortableContext } from "./block-sortable-context";

export const useBlockSortable = () => useContext(BlockSortableContext);
